export class AccountUpdate
{
    storeid: string;
    password: string;
    accounttype: string;
    role: string;      
    commissionmodel: string;
    notificationurl: string;
    rate: string; 
}


// WEBPACK FOOTER //
// /tmp/build_713add00/src/models/accountupdatemodel.ts